var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import moment from "moment";
import { FlexContainer } from "../grid/flexcontainer";
import { Table } from "../components/table";
import * as ReactDOM from "react-dom";
import { bind } from "decko";
import { Button } from "./button";
import { Grid } from "../grid/grid";
import GridItem from "../grid/griditem";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const calendarOverlayClass = css({
    color: getThemeColorVar("typo", "default"),
    zIndex: 12000,
    backgroundColor: getThemeColorVar("white", undefined),
    boxShadow: `0 0 15px ${getThemeColorVar("background", "light")}`,
    padding: "10px",
    position: "absolute",
    right: 0,
    marginTop: "5px",
    minWidth: "290px",
    "&:before": {
        position: "absolute",
        content: '"▲"',
        display: "block",
        color: getThemeColorVar("white", undefined),
        textShadow: `0 -2px 3px ${getThemeColorVar("background", "lighter")}`,
        right: "15px",
        top: "-15px",
    },
    "table td": {
        textAlign: "center",
        padding: "0px",
        minWidth: "50px",
    },
    button: {
        padding: "10px",
        "&:hover": {
            backgroundColor: getThemeColorVar("background", "lighter"),
        },
        width: "100%",
    },
});
const disabledClass = css({
    color: getThemeColorVar("typo", "light"),
    cursor: "not-allowed",
});
const activeClass = css({
    "> button": {
        color: getThemeColorVar("white", undefined),
        fontWeight: 600,
        backgroundColor: getThemeColorVar("primary", "default"),
        "&:hover": {
            backgroundColor: getThemeColorVar("primary", "light"),
        },
    },
});
export class CalendarOverlay extends React.Component {
    constructor(props) {
        super(props);
        const date = this.props.value && isFinite(this.props.value.getDate())
            ? this.props.value
            : new Date();
        this.state = {
            internalValue: moment(date),
        };
    }
    handleOutsideClick(event) {
        try {
            const domNode = ReactDOM.findDOMNode(this);
            if (domNode &&
                domNode.contains &&
                !domNode.contains(event.target)) {
                this.props.onClose && this.props.onClose();
            }
        }
        catch (e) {
        }
    }
    componentWillMount() {
        document.addEventListener("click", this.handleOutsideClick.bind(this));
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.handleOutsideClick.bind(this));
    }
    renderCalendarBody() {
        const { internalValue } = this.state;
        const startWeekdayIndex = internalValue.clone().startOf("month").weekday();
        const displayLength = internalValue.daysInMonth() + startWeekdayIndex;
        const displayStartDay = internalValue
            .clone()
            .startOf("month")
            .subtract(startWeekdayIndex, "days");
        const dates = [];
        for (let week = 0; week < Math.ceil(displayLength / 7); week++) {
            dates[week] = [0, 1, 2, 3, 4, 5, 6].map((e, i) => {
                return displayStartDay.clone().add(week, "weeks").add(i, "days");
            });
        }
        return dates.map((week, index) => {
            return (React.createElement("tr", { key: index }, week.map((day) => this.renderCalendarDay(day))));
        });
    }
    renderCalendarDay(day) {
        const disabled = day.month() !== this.state.internalValue.month();
        const classes = [];
        disabled && classes.push(disabledClass);
        moment(this.props.value || 0).isSame(day.toDate()) &&
            classes.push(activeClass);
        if (disabled) {
            return (React.createElement("td", { key: day.dayOfYear(), className: cx(classes) }, day.date()));
        }
        return (React.createElement("td", { key: day.dayOfYear(), className: cx(classes) },
            React.createElement(Button, { formType: "button", type: "tertiary", onClick: (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    this.props.onUpdate(day.toDate());
                } }, day.date())));
    }
    renderCalendarHead() {
        const days = [
            ...moment.localeData().weekdaysMin(),
            ...moment.localeData().weekdaysMin(),
        ];
        const firstDayOfWeek = moment.localeData().firstDayOfWeek();
        const localizedWeekdays = days.slice(firstDayOfWeek, firstDayOfWeek + 7);
        return (React.createElement("thead", null,
            React.createElement("tr", null, localizedWeekdays.map((day) => {
                return React.createElement("th", { key: day }, day);
            }))));
    }
    setDate(date) {
        this.setState({ internalValue: date });
    }
    prevMonth() {
        this.setState({
            internalValue: this.state.internalValue.clone().subtract(1, "month"),
        });
    }
    nextMonth() {
        this.setState({
            internalValue: this.state.internalValue.clone().add(1, "month"),
        });
    }
    render() {
        const date = this.state.internalValue;
        return (React.createElement("div", { className: cx(calendarOverlayClass) },
            React.createElement(FlexContainer, { direction: "col", spaceBetween: "md" },
                React.createElement(Grid, { columnSpec: "fit-content(100%) 1fr fit-content(100%)" },
                    React.createElement(GridItem, { justifySelf: "center", alignSelf: "center" },
                        React.createElement(Button, { type: "tertiary", formType: "button", onClick: () => this.prevMonth(), icon: "chevron_left" })),
                    React.createElement(GridItem, { justifySelf: "center", alignSelf: "center" },
                        moment.localeData().months()[date.month()],
                        " ",
                        date.year()),
                    React.createElement(GridItem, { justifySelf: "center", alignSelf: "center" },
                        React.createElement(Button, { formType: "button", type: "tertiary", onClick: () => this.nextMonth(), icon: "chevron_right" }))),
                React.createElement("hr", null)),
            React.createElement(FlexContainer, { direction: "col" },
                React.createElement(Table, null,
                    this.renderCalendarHead(),
                    React.createElement("tbody", null, this.renderCalendarBody())))));
    }
}
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CalendarOverlay.prototype, "handleOutsideClick", null);
export default CalendarOverlay;
//# sourceMappingURL=calenderoverlay.js.map